import { FaChevronUp } from "react-icons/fa";

export function FixedPlugin() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className="fixed bottom-0 right-0 mr-10 mb-4 bg-[#303133] h-10 w-10 flex justify-center items-center rounded-sm cursor-pointer"
      onClick={handleScrollToTop}
    >
      <FaChevronUp color="#fff" />
    </div>
  );
}
